import { EventEmitter } from "events";

interface CallButtonOptions {
  el: HTMLElement;
}

class CallButtonStore {
  private _emitter = new EventEmitter();
  private _options: CallButtonOptions;


  mountCallButton(opts: CallButtonOptions) {
    this._options = opts;
    this._emitter.emit("mounted");
  }

  onMounted(callback: () => void) {
    this._emitter.addListener("mounted", callback);
  }

  getContainer() {
    if (!this._options) {
      return null;
    }

    return this._options.el;
  }
}

export default CallButtonStore;
